import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="privacy-policy__container">
        <h1 className="privacy-policy__title">Privacy Policy</h1>
        <p className="privacy-policy__last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        
        <section className="privacy-policy__section">
          <h2 className="privacy-policy__subtitle">1. Introduction</h2>
          <p>Welcome to ChoiceRealms. We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services.</p>
        </section>

        <section className="privacy-policy__section">
          <h2 className="privacy-policy__subtitle">2. Information We Collect</h2>
          <p>We collect personal information that you provide to us such as name, email address, and gameplay data. We also automatically collect certain information when you visit, use or navigate the platform. This information does not reveal your specific identity but may include device and usage information.</p>
        </section>

        <section className="privacy-policy__section">
          <h2 className="privacy-policy__subtitle">3. How We Use Your Information</h2>
          <p>We use personal information collected via our platform for a variety of business purposes described below:</p>
          <ul className="privacy-policy__list">
            <li>To provide and maintain our service</li>
            <li>To manage user accounts</li>
            <li>To send you marketing and promotional communications</li>
            <li>To respond to user inquiries/offer support to users</li>
            <li>To improve our platform and user experience</li>
          </ul>
        </section>

        <section className="privacy-policy__section">
          <h2 className="privacy-policy__subtitle">4. Will Your Information Be Shared With Anyone?</h2>
          <p>We only share information with your consent, to comply with laws, to provide you with services, to protect your rights, or to fulfill business obligations. We do not sell your personal information.</p>
        </section>

        <section className="privacy-policy__section">
          <h2 className="privacy-policy__subtitle">5. How Long Do We Keep Your Information?</h2>
          <p>We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy policy, unless a longer retention period is required or permitted by law.</p>
        </section>

        <section className="privacy-policy__section">
          <h2 className="privacy-policy__subtitle">6. How Do We Keep Your Information Safe?</h2>
          <p>We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, please also remember that we cannot guarantee that the internet itself is 100% secure.</p>
        </section>

        <section className="privacy-policy__section">
          <h2 className="privacy-policy__subtitle">7. Do We Collect Information From Minors?</h2>
          <p>We do not knowingly collect data from or market to children under 18 years of age.</p>
        </section>

        <section className="privacy-policy__section">
          <h2 className="privacy-policy__subtitle">8. Your Privacy Rights</h2>
          <p>You have the right to review, change, or terminate your account at any time. If you are resident in the European Economic Area and you believe we are unlawfully processing your personal information, you also have the right to complain to your local data protection supervisory authority.</p>
        </section>

        <section className="privacy-policy__section">
          <h2 className="privacy-policy__subtitle">9. Updates to This Policy</h2>
          <p>We may update this privacy policy from time to time. The updated version will be indicated by an updated "Revised" date and the updated version will be effective as soon as it is accessible.</p>
        </section>

        <section className="privacy-policy__section">
          <h2 className="privacy-policy__subtitle">10. How Can You Contact Us About This Policy?</h2>
          <p>If you have questions or comments about this policy, you may email us at privacy@choicerealms.com or by post to:</p>
          <p>ChoiceRealms<br />123 RPG Street<br />Game City, GC 12345<br />United States</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
